import { useEffect, useState } from "react";
import "./SnippetPicker.css";
import { SnippetCard } from "./SnippetCard";
import { Snippet } from "winslow-core";
import {
  selectCurrentCollectionId,
  selectEditingCollection,
  selectSidebarSnippet,
  selectUser,
  setSidebarSnippet,
} from "../../redux/features/appData";
import { useSelector } from "react-redux";
import { NEW_SNIPPET_ID } from "../ai/AISidebarAsk";

type SnippetPickerProps = {
  snippets: Snippet[];
  onNew: any;
};

export const SnippetPicker = ({ snippets, onNew }: SnippetPickerProps) => {
  const storeUser = useSelector(selectUser);
  const sidebarSnippet = useSelector(selectSidebarSnippet);
  const currentCollection = useSelector(selectEditingCollection);

  useEffect(() => {
    // if (!selectedSnippetId && snippets.length > 0) {
    //     setSelectedSnippetId(snippets[0].id);
    // }
  }, []);

  return (
    <>
      <div id="snippet-picker">
        <div className="snippet-picker-header">
          <div className="snippet-picker-title">
            {snippets.length > 0
              ? "Quick Replies"
              : "No Relevant Quick Replies"}
          </div>
          <div className="snippet-picker-create" onClick={() => onNew()}>
            Create New
          </div>
        </div>
        {snippets.length > 0 && (
          <div className="snippet-picker-snippets">
            {snippets.map((snippet: Snippet, i: number) => {
              if (i > 2) {
                return <></>;
              }

              // const isNew = snippet.id === NEW_SNIPPET_ID;

              return (
                <SnippetCard
                  key={snippet.id}
                  snippet={snippet}
                  selected={
                    sidebarSnippet ? sidebarSnippet.id === snippet.id : false
                  }
                />
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};
